import React, { useRef, useLayoutEffect, useState } from 'react';
import { CopyIcon, CheckIcon } from '@phosphor-icons/react';
import CollapsibleSection from '../../OpenApiTab/components/CollapsibleSection';
import JsonInputField from '../../../../../Utility/JsonInputField/JsonInputField';
import { RootState, useAppSelector } from '../../../../../../store';

interface ResultViewerProps {
    title: string;
    result: any;
}

const ResultViewer: React.FC<ResultViewerProps> = ({ title, result }) => {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const containerRef = useRef<HTMLDivElement>(null);
    const [copied, setCopied] = useState<{ [key: string]: boolean }>({});
    const [resultOpen, setResultOpen] = useState(true);

    useLayoutEffect(() => {
        setResultOpen(true);
    }, [result]);

    const handleCopy = (text: string, key: string) => {
        navigator.clipboard.writeText(text);
        setCopied((prev) => ({ ...prev, [key]: true }));
        setTimeout(() => {
            setCopied((prev) => ({ ...prev, [key]: false }));
        }, 2000);
    };

    if (result === null || result === undefined) return null;

    return (
        <div ref={containerRef} className="pt-0">
            <div className="flex flex-col gap-4">
                <div className="mb-0 flex items-center gap-2">
                    <h4 className="m-0 p-0">{title}</h4>
                    <div onClick={() => handleCopy(result, 'full-result')}>
                        <span className="h-full w-full text-layout-textcolor hover:text-primary flex items-center gap-1 transition-colors cursor-pointer">
                            {copied['full-result'] ? (
                                <CheckIcon className="w-4 h-4" />
                            ) : (
                                <CopyIcon className="w-4 h-4" />
                            )}
                        </span>
                    </div>
                </div>

                <CollapsibleSection
                    title={i18n.translate({ id: 'mcp.result.title', sourceName: 'MCP' }) || 'Result'}
                    isOpen={resultOpen}
                    onToggle={() => setResultOpen((s) => !s)}
                    titleTooltip={resultOpen ? 'Hide result' : 'Show result'}
                >
                    <div className="mt-3 py-3 px-5">
                        <div className="rounded border border-layout-borderColor">
                            <JsonInputField
                                value={result}
                                readOnly={true}
                                showCopyButton={true}
                                onCopy={(text) => handleCopy(text, 'result-content')}
                                minRows={5}
                                maxRows={20}
                            />
                        </div>
                    </div>
                </CollapsibleSection>
            </div>
        </div>
    );
};

export default ResultViewer;
